var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "회사소개",
      "sc": "에프원시큐리티가 여러분의 정보를 함께 보호하겠습니다.",
      "tabActive": "인사말",
      "icon": "/images/sub/visual/sv1-icon.svg",
      "bg": "/images/sub/visual/sv1.png"
    }
  }), _c('section', {
    staticClass: "sub-section pb-28 pb-md-28 pb-lg-54 greeting-bg"
  }, [_c('v-container', [_c('div', {
    staticClass: "sub-tit-wrap"
  }, [_c('h3', {
    staticClass: "sub-tit--lg mb-12 mb-lg-24",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('span', {
    staticClass: "color-point"
  }, [_vm._v("안전한 디지털 보안기술")]), _vm._v(" 의 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 파트너 F1 Security 입니다 ")]), _c('p', {
    staticClass: "page-text--lg color-gray"
  }, [_vm._v(" 에프원시큐리티는 정보보호컨설팅, 솔루션 개발을 전문으로 하는 여러분의 보안 파트너입니다. ")])])])], 1), _c('div', {
    staticClass: "greeting-bg2"
  }), _c('section', {
    staticClass: "pt-40 pt-md-40 pt-lg-80 sub-section--last"
  }, [_c('v-container', [_c('p', {
    staticClass: "page-text color-gray mb-8 mb-lg-20"
  }, [_vm._v(" 안녕하십니까? 에프원시큐리티 대표이사 이대호입니다. ")]), _c('p', {
    staticClass: "page-text color-gray mb-8 mb-lg-20"
  }, [_vm._v(" 에프원시큐리티는 2011년 설립이래 고객의 소중한 정보자산을 안전하게 보호하기 위한 보안솔루션과 서비스를 제공하며 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" ISMS, ISMS-P, ISO27001 등 인증컨설팅과 개인정보보호/관리체계 컨설팅을 핵심 사업분야로 하고 있습니다. ")]), _c('p', {
    staticClass: "page-text color-gray mb-8 mb-lg-20"
  }, [_vm._v(" 다년간 다양한 고객의 정보보호 컨설팅을 기반으로 웹방화벽/웰쉘탐지/웹악성코드분석탐지 등 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 솔루션의 필요성을 가지고 자사 솔루션 개발에 지속적으로 노력해왔습니다. ")]), _c('p', {
    staticClass: "page-text color-gray mb-20 mb-lg-50"
  }, [_vm._v(" 고객 가치를 극대화하기 위한 정보보호 컨설팅, 정보보호 솔루션 개발을 전문으로 세계 시장을 대표하는 보안 기업으로 정진하는 정보보호 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 파트너로 쉬지 않고 노력하겠습니다. 다가올 미래는 정보보호가 IT서비스의 경쟁력이 될 수 있는 시대라고 판단되며, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 에프원시큐리티와 함께 정보보호 향상을 고객과 같이 실현 할 수 있도록 노력하겠습니다. "), _c('br'), _vm._v(" 앞으로도 변함없는 성원 부탁드리며, 고객 여러분들의 든든한 파트너가 될 것을 약속합니다. "), _c('br'), _vm._v(" 감사합니다. ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" (주)에프원시큐리티 대표이사 "), _c('strong', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("이대호")])])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }